import React from "react";
import { Nav } from "reactstrap";
import { productConfiguratorTabsEnum } from "variables/enums";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";
import { useTranslate } from "hooks";
import cx from "classnames";
import { TabItem } from "./TabItem";

const tabs = [
  {
    id: productConfiguratorTabsEnum.singleSelection,
    labelKey: "PRODUCT_SINGLE_SELECTION",
  },
  {
    id: productConfiguratorTabsEnum.productSuggestion,
    labelKey: "PRODUCT_SUGGESTION",
  },
];

export const ProductResultTabs = () => {
  const { changeActiveTab } = useProductConfiguratorStore.use.actions();
  const activeTab = useProductConfiguratorStore.use.activeTab();
  const translate = useTranslate();

  return (
    <Nav tabs className={cx("w-100 d-flex border-0")}>
      {tabs.map((tab) => (
        <TabItem
          key={tab.id}
          tabId={tab.id}
          label={translate(tab.labelKey)}
          isActive={activeTab === tab.id}
          onClick={changeActiveTab}
        />
      ))}
    </Nav>
  );
};
